import React from "react";
import styles from './Footer.module.css'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaWhatsapp, FaTiktok } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className={styles.footerContainer}>
            <div className={styles.footerContent}>
                <div className={styles.footerBrand}>
                    <span className={styles.brandName}>BY RAÍCES</span>
                    <span className={styles.brandLine}>Encontrá tu próximo comienzo.</span>
                </div>
                <div className={styles.socialMedia} aria-label="Redes sociales de By Raíces">
                    <a href="https://www.facebook.com/byraicesmendoza" className={styles.socialIcon} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                        <FaFacebookF />
                    </a>
                    <a href="https://www.instagram.com/byraicesoficial/" className={styles.socialIcon} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <FaInstagram />
                    </a>
                    <a href="https://www.linkedin.com/company/byraices/mycompany/" className={styles.socialIcon} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                        <FaLinkedinIn />
                    </a>
                    {/* <a href="https://www.youtube.com/" className={styles.socialIcon} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                        <FaYoutube />
                    </a> */}
                    <a href="https://wa.me/542617137992?text=Hola%20By%20Ra%C3%ADces%2C%20quiero%20recibir%20m%C3%A1s%20informaci%C3%B3n." className={styles.socialIcon} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                        <FaWhatsapp />
                    </a>
                    <a href="https://www.tiktok.com/@byraicesmendoza" className={styles.socialIcon} target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                        <FaTiktok />
                    </a>
                </div>
            </div>
            <div className={styles.legalSection}>
                <h2 className={styles.legalTitle}>Información legal</h2>
                <p className={styles.legalText}>
                    By Raíces (bajo la sociedad Ditova SAS) no ejerce el corretaje inmobiliario. Cada oficina es de propiedad y gestión independiente. En cumplimiento de las leyes vigentes que regulan el corretaje inmobiliario, Ley Nacional 25.028, Ley 22.802 de Lealtad Comercial, Ley 24.240 de Defensa al Consumidor, las normas del Código Civil y Comercial de la Nación y constitucionales, los agentes y gestores de By Raíces no ejercen el corretaje inmobiliario. Todas las operaciones inmobiliarias son objeto de intermediación y conclusión por parte de los corredores públicos inmobiliarios colegiados, cuyos datos se exhiben en cada publicación de propiedad objeto de comercialización.
                </p>
            </div>
            <div className={styles.footerBottom}>
                <span>© {new Date().getFullYear()} By Raíces</span>
                <span>Una nueva forma de encontrar tu lugar.</span>
            </div>
        </footer>
    )
}

export default Footer;